import { isFileTypeInList } from './util';
import config from './config';

class Node {
  constructor(nodeData) {
    this.id = nodeData.id;
    this.edges = [];
    this.x = 0;
    this.y = 0;
    this.width = 0;
    this.height = 0;
    this.horizontalIndex = -1;
    this.layerIndex = -1;
    this.verticalIndex = -1;
    this.temporary = !!nodeData.temporary;
    this.hasEndEdge = nodeData.terminalMessage;
    this.data = nodeData;
  }

  addEdge(edge) {
    this.edges = this.edges.concat(edge);
  }

  cleanNodePositionData() {
    this.x = 0;
    this.y = 0;
    this.width = 0;
    this.height = 0;
    this.horizontalIndex = -1;
    this.verticalIndex = -1;
    this.layerIndex = -1;
  }

  putAttachmentsIncludedTypes() {
    this.includedTypesInAttachments = [];
    const allTypes = config.files.types;
    const links = this.data.botAttachments.map(attachment => attachment.link);
    for (const type of allTypes) {
      if (isFileTypeInList(type, links)) {
        this.includedTypesInAttachments.push(type);
      }
    }
  }
}

class Edge {
  constructor(id, text, source) {
    this.id = id;
    this.text = text;
    this.source = source;
    this.destination = null;
    this.folded = false;
    this.display = true;
    this.x = 0;
    this.y = 0;
    this.shapePoints = [];
  }

  isNotEqual(otherEdge) {
    return otherEdge.id !== this.id || otherEdge.text !== this.text || otherEdge.x !== this.x
      || otherEdge.y !== this.y || otherEdge.folded !== this.folded || otherEdge.destination !== this.destination;
  }

  addShapePoint(point) {
    this.shapePoints.push(point);
  }

  cleanDuplicateShapesPoints() {
    this.shapePoints = this.shapePoints.filter((point, pos, arr) => pos === arr.findIndex(otherPoint => otherPoint.x === point.x && otherPoint.y === point.y));
  }

  cleanShapePoints() {
    this.shapePoints = [];
  }

  setDestination(vertex) {
    this.destination = vertex;
  }
}


class Point {
  constructor(x, y) {
    this.x = x;
    this.y = y;
  }
}

export { Node, Edge, Point };



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/graph/Structures.js